"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _icons = require("./icons");
var _theme = _interopRequireDefault(require("../../theme"));
var _excluded = ["size", "color", "icon", "testID", "title", "borderWidth"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Icon = function Icon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _theme["default"].indigo60 : _ref$color,
    icon = _ref.icon,
    _ref$testID = _ref.testID,
    testID = _ref$testID === void 0 ? icon : _ref$testID,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? icon : _ref$title,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
    props = _objectWithoutProperties(_ref, _excluded);
  var ICON = _icons.icons[icon];
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 ".concat(ICON === null || ICON === void 0 ? void 0 : ICON.viewBox),
    style: {
      width: size,
      height: size,
      minWidth: size,
      borderWidth: borderWidth,
      borderStyle: 'solid'
    },
    fill: "none",
    "data-testid": testID,
    "aria-labelledby": title,
    role: "img"
  }, props), /*#__PURE__*/_react["default"].createElement("title", {
    id: title
  }, title), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: ICON === null || ICON === void 0 ? void 0 : ICON.path,
    fill: color
  }));
};
Icon.propTypes = {
  icon: _propTypes["default"].any.isRequired
};
var _default = exports["default"] = Icon;